import { BudgetAllowance, BudgetUse } from '@frontend/budget/types';
import { FormattedMessage } from 'react-intl';

import KioskList from '../../../components/kiosk-list.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import useReturnOverview from './return-overview.controller';

const ID = 'return-overview';
const ReturnOverview = () => {
    const viewProps = useReturnOverview();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: viewProps.isLoading,
                onClose: () => viewProps.setIsLoading(false)
            }}
            containerClassName='flex size-full flex-col overflow-x-hidden overflow-y-auto p-6 gap-3'>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='text-foreground-default justify-end'>
                    <FormattedMessage
                        defaultMessage='Scan your product below or select it from the list to return it'
                        id='kiosk.wizard.return-overview.scan-or-select'
                        description='Instruction text on the return overview screen, prompting users to scan or select a product to return'
                    />
                </div>
                <KioskList<BudgetUse & BudgetAllowance>
                    id='return-overview'
                    fetch={viewProps.fetchData}
                    rowElement={(obj) => (
                        <ProductCard
                            styles={
                                !obj.allowed
                                    ? {
                                          container:
                                              'bg-background-default border-border-default inline-flex w-full items-start justify-start gap-3 self-stretch rounded-xl border p-3 opacity-50'
                                      }
                                    : undefined
                            }
                            key={obj.id}
                            product_id={obj.product_id}
                            description={
                                !obj.allowed ? (
                                    <div className='justify-start text-sm font-medium'>
                                        <FormattedMessage
                                            id='kiosk.wizard.return-overview.not-allowed-to-return'
                                            defaultMessage='You are not allowed to return this product'
                                        />
                                    </div>
                                ) : undefined
                            }
                            action={
                                !obj.allowed
                                    ? undefined
                                    : {
                                          text: (
                                              <FormattedMessage
                                                  id='kiosk.wizard.return-overview.return-this-product'
                                                  defaultMessage='Return this product'
                                              />
                                          ),
                                          onClick: () => viewProps.onClick(obj)
                                      }
                            }
                        />
                    )}
                    emptyText={
                        <FormattedMessage
                            id='kiosk.wizard.return-overview.no-products'
                            defaultMessage='No products to return'
                        />
                    }
                />
            </div>
        </WizardScreenContainer>
    );
};

export default ReturnOverview;
